export const defaultUserCompanySettings = {
    id: 23,
    bcc_active: 0,
    bcc_pdf_varification: 0,
    bcc_email: "",
    subject: "",
    finger_sign: 0,
    signature_type: 0,
    remove_pdf: 0,
    print_doc: 0,
    outgoing_email: 1,
    active_footer_email: 0,
    footer_email: "",
    active_invitation: 0,
    invitation_message: "",
    pricing_format_amount: "sv-SE",
    pricing_format_currency: "after_value",
    pricing_format_example: "1 000,50",
    system_currency: "SEK"
}